import { TimePeriod } from '../../../enum/time-period.enum';
import { OrderPriceBreakup } from '../interface/order-price.breakup.interface';
import { CreateOrderItemDto } from './create-order.dto';

export class CreateOrderQuoteDto {
  period: TimePeriod;
  items: CreateOrderItemDto[];
}

export interface OrderQuoteItem {
  organisation: string;
  organisationName: string;
  plan_id: string;
  plan: { _id: string; name: string; type: string };
  priceBreakup: OrderPriceBreakup;
}

export interface OrderQuote {
  period: string;
  currency: string;
  items: OrderQuoteItem[];
  priceBreakup: OrderPriceBreakup;
  payableAmount: number;
}
